module.exports = __webpack_public_path__ + "img/header-banner.jpg?6480e06e732aadac5e4cbefdb105f410";